<template>
  <div class="practice-record">
    <ul v-if="dataList.length" class="practice-record__list">
      <li
        v-for="(item, index) in dataList"
        :key="index"
        class="practice-record__list--item"
        @click="toDetail(item)"
      >
        <div class="item-info">
          <p class="item-info__name">
            <span class="name-txt">{{ item.taskName }}</span>
            <i v-if="item.status === 1" class="icon-arrow-right-s-line t-iconfont"></i>
          </p>
          <p class="item-info__time">
            <span>
              <i class="icon-calendar-schedule-line t-iconfont"></i>
              {{ xbb.formatTime(item.completedTime * 1000, 'yyyy-MM-dd HH:mm') }}
            </span>
            <span class="item-info__cutline"></span>
            <span>
              <i class="icon-time-line t-iconfont"></i>
              <!-- {{ item.duration }}分钟 -->
              {{ item.duration }}
            </span>
          </p>
        </div>
        <div class="item-status">
          <!-- 分析完成 -->
          <template v-if="item.status === 1 && typeof item.score === 'number'">
            <div class="item-status__complete">
              <span class="item-status__complete--score">{{ item.score || 0 }}</span>
              <span style="line-height: 20px">分</span>
            </div>
          </template>
          <!-- 分析中 -->
          <template v-else>
            <div class="item-status__ing">分析中</div>
          </template>
        </div>
      </li>
      <li v-if="pageHelper.hasRight" class="practice-record__list--more">
        <span @click="toMore">加载更多</span>
      </li>
    </ul>
    <div v-else class="empty-box">
      <img alt="" :src="aiLogo" />
      <p>暂无完成的陪练任务</p>
    </div>
  </div>
</template>

<script setup>
import aiLogo from '@/assets/ai-logo-empty.png'
import { onMounted, ref, defineProps, defineEmits, defineOptions, defineExpose } from 'vue'
import xbb from '@xbb/xbb-utils'
// options
defineOptions({
  name: 'PracticeRecord'
})
// 接口请求
import { getPracticeRecordList } from '@/api/ai-board.js'
// emit
const emit = defineEmits(['on-detail'])
// props
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  }
})
// data
const dataList = ref([])
const loading = ref(false)
const pageHelper = ref({
  currentPageNum: 1,
  pageSize: 10,
  hasRight: true
})
// methods
const getDataList = (isMore = false) => {
  if (loading.value) return
  loading.value = true
  if (isMore) {
    pageHelper.value.currentPageNum += 1
  } else {
    pageHelper.value.currentPageNum = 1
  }
  getPracticeRecordList({
    page: pageHelper.value.currentPageNum,
    pageSize: pageHelper.value.pageSize
  })
    .then((res) => {
      const list = res.result.practiceRecordList || []
      if (isMore) {
        dataList.value.push(...list)
      } else {
        dataList.value = list
      }
      pageHelper.value = {
        ...pageHelper.value,
        ...res.result.pageHelper
      }
    })
    .finally(() => {
      loading.value = false
    })
}
const toMore = () => {
  console.log('加载更多')

  // 如果没有更多了
  if (!pageHelper.value.hasRight) return

  getDataList(true)
}
const toDetail = (item) => {
  if (item.status === 0) {
    return
  }
  emit('on-detail', item)
}
// computed
// lice-cycle
onMounted(() => {
  getDataList()
  console.log('practice-record params', props.params)
})

defineExpose({
  getDataList
})
</script>

<style lang="less" scoped>
.practice-record {
  position: relative;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 12px;
  &__list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &--item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      border-radius: 16px;
      background: #ffffff;
      border: 1px solid #f2f3f5;
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.05);

      .item-info {
        display: flex;
        flex-direction: column;

        &__name {
          .name-txt {
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #323233;
            display: inline-block;
          }

          .t-iconfont {
            color: #969799;
          }
        }

        &__cutline {
          width: 1px;
          height: 12px;
          background-color: #e5e6eb;
        }

        &__time {
          height: 16px;
          display: flex;
          align-items: center;
          margin-top: 4px;
          font-size: 12px;
          gap: 12px;
          color: #323233;

          .t-iconfont {
            margin-right: 2px;
            font-size: 13px;
            width: 13px;
            height: 13px;
            color: #969799;
          }
        }
      }

      .item-status {
        font-size: 14px;
        color: #969696;

        &__ing {
          box-sizing: border-box;
          line-height: 16px;
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 16px;
          color: #646566;
          background-color: #f2f3f5;
        }

        &__complete {
          display: flex;
          align-items: flex-end;
          gap: 4px;
          font-size: 12px;
          color: #969799;

          &--score {
            font-size: 24px;
            font-weight: 600;
            color: #7a52f4;
          }
        }
      }
    }

    &--more {
      display: flex;
      justify-content: center;
      text-align: center;
      color: #248df5;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .empty-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    img {
      height: 112px;
      margin-bottom: 16px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #969799;
    }
  }
}
</style>
